<template>
  <el-card v-loading="loading">
    <el-form>
      <el-form-item label="Late Move-Out Fee in Percentage (in addition to normal rental charge)">
        <el-input v-model="penalty"></el-input>
      </el-form-item>
      <el-button @click="savePenalty">Save</el-button>
    </el-form>
  </el-card>
</template>

<script>
import axios from 'axios';
import { ADMIN_API_BASE } from '../env';

export default {
  name: 'FacilityPenaltySettings',
  props: { facility: { type: String, required: true } },
  async mounted() {
    await this.getFacility();
  },
  watch: {
    async facility() {
      await this.getFacility;
    },
  },
  data() {
    return {
      penalty: 0,
      loading: false,
    };
  },
  methods: {
    async getFacility() {
      this.loading = true;
      const response = await axios.get(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.$root.$data.setFacilityDataAction(response.data);
      this.penalty = response.data.penalty;
      this.loading = false;
    },
    async savePenalty() {
      this.loading = true;
      try {
        await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
          penalty: this.penalty,
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.loading = true;
        await this.getFacility();
        this.loading = false;
        this.$message.success({
          title: 'Success',
          message: 'Penalty updated successfully',
        });
      } catch (err) {
        this.$message.error({
          title: 'Error',
          message: err.message ? err.message : err.resposne.data.toUpperCase(),
        });
      }
      this.loading = false;
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/FacilityPenalty.vue